<button
    nz-button
    nzSize="large"
    nzType="primary"
    class="a-fx a-fx-center-center"
    type="button"
    (click)="onLoginAuth0()"
>
    <span class="inner a-fx a-fx-center-center">
        <img [src]="'mirakl-logo.svg' | assetsPath" alt="mirakl logo" />
        <span>
            {{ 'portal.login-mirakl' | translate }}
        </span>
    </span>
</button>
